import type { LucideIcon, LucideProps } from 'lucide-react'
import { forwardRef } from 'react'

import aiLightning from 'src/shared/assets/icons/utils/ai-lightning.png'

export const AiLightning: LucideIcon = forwardRef<SVGSVGElement, LucideProps>(({ size = 24, ...props }, ref) => {
  return (
    <svg
      ref={ref}
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <image href={aiLightning} width="24" height="24" preserveAspectRatio="xMidYMid meet" />
    </svg>
  )
})

AiLightning.displayName = 'AiLightning'
